export { default as InjectableTooltip } from "./InjectableTooltip";
